package org.moxultimate.topwithmox.dashboard.di

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.koin.dsl.module
import org.moxultimate.topwithmox.dashboard.api.DashboardRepository
import org.moxultimate.topwithmox.dashboard.DashboardViewModel

/**
 * DashboardModule
 * Koin bindings for the dashboard feature: HttpClient, repository, and ViewModel.
 * HttpClient is a singleton so the underlying JS engine is reused across calls.
 * ViewModel is a factory so each composable gets a fresh instance with its own scope.
 */
val dashboardModule = module {

    single {
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
        }
    }

    single {
        DashboardRepository(httpClient = get())
    }

    factory {
        DashboardViewModel(repository = get())
    }
}
